var map = {
	"./1.svg": 31580,
	"./2.svg": 24744,
	"./3.svg": 89343,
	"./add.svg": 54966,
	"./alipay.svg": 98471,
	"./applet.svg": 51903,
	"./article-create.svg": 3636,
	"./article-ranking.svg": 58133,
	"./article.svg": 93926,
	"./auto-scale.svg": 65595,
	"./back.svg": 15694,
	"./base-data.svg": 65468,
	"./bell.svg": 70454,
	"./bind-phone.svg": 85144,
	"./branch-boke.svg": 87707,
	"./branch-frabric.svg": 27423,
	"./branch-maker.svg": 25641,
	"./branch-shop.svg": 25459,
	"./c1.svg": 11005,
	"./c2.svg": 31014,
	"./c3.svg": 22355,
	"./c4.svg": 21314,
	"./camera.svg": 94402,
	"./camera1.svg": 1291,
	"./cart-down.svg": 31172,
	"./change-theme.svg": 76026,
	"./chart.svg": 92492,
	"./client-skin.svg": 68563,
	"./close.svg": 41008,
	"./cloth.svg": 24156,
	"./code.svg": 5819,
	"./contactus.svg": 60736,
	"./customerservices.svg": 75085,
	"./dashboard.svg": 79997,
	"./data-upload.svg": 40507,
	"./deamon.svg": 1104,
	"./delete.svg": 57276,
	"./diagnosis.svg": 10872,
	"./down.svg": 94055,
	"./download (2).svg": 73828,
	"./download.svg": 42214,
	"./edit.svg": 52867,
	"./empty.svg": 63438,
	"./error.svg": 11811,
	"./example.svg": 20871,
	"./exit-fullscreen.svg": 18203,
	"./eye-open.svg": 1823,
	"./eye.svg": 22549,
	"./fullscreen.svg": 12119,
	"./gouxuan.svg": 45503,
	"./gouxuan1.svg": 80449,
	"./guide.svg": 13433,
	"./hamburger-closed.svg": 21819,
	"./hamburger-opened.svg": 91845,
	"./heart.svg": 27628,
	"./histoires.svg": 97886,
	"./home.svg": 63148,
	"./home1.svg": 72457,
	"./info.svg": 78058,
	"./international.svg": 69541,
	"./introduce.svg": 31035,
	"./language.svg": 18938,
	"./link.svg": 41357,
	"./loading.svg": 63658,
	"./loading1.svg": 84798,
	"./medtruansfer.svg": 11467,
	"./moneyaccount.svg": 83449,
	"./myreg.svg": 5030,
	"./nested.svg": 92289,
	"./new.svg": 28057,
	"./next.svg": 93449,
	"./outlinepay.svg": 51286,
	"./package.svg": 95231,
	"./password.svg": 50748,
	"./permission.svg": 70676,
	"./person.svg": 43986,
	"./personnel-info.svg": 99683,
	"./personnel-manage.svg": 81269,
	"./personnel.svg": 29028,
	"./play.svg": 18675,
	"./pointleft.svg": 3962,
	"./prev.svg": 53010,
	"./qq.svg": 89663,
	"./refresh.svg": 46163,
	"./reply.svg": 28312,
	"./require.svg": 34160,
	"./reward.svg": 69713,
	"./role.svg": 92239,
	"./scales.svg": 23277,
	"./scales1.svg": 23937,
	"./search.svg": 3605,
	"./search1.svg": 40103,
	"./setting.svg": 6857,
	"./setting1.svg": 51735,
	"./shared.svg": 48851,
	"./shift.svg": 1077,
	"./shop.svg": 58439,
	"./size.svg": 76587,
	"./star.svg": 88679,
	"./success.svg": 98194,
	"./table.svg": 5326,
	"./tel.svg": 22038,
	"./tree.svg": 9968,
	"./up.svg": 63752,
	"./upload.svg": 28709,
	"./user.svg": 57800,
	"./video.svg": 69171,
	"./warn.svg": 98413,
	"./wechat.svg": 87900,
	"./wx.svg": 88403
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42007;